import JustValidate from "just-validate";
import Swal from "sweetalert2";

document.addEventListener("DOMContentLoaded", function () {
  const popupMain = document.getElementById("PopupMain");
  if (!popupMain) return;

  const backdrop = document.getElementById("festivePopupBackdrop");
  const bannerView = document.getElementById("festiveBannerView");
  const formView = document.getElementById("festiveFormView");
  const successView = document.getElementById("festiveSuccessView");

  const closeBannerBtn = document.getElementById("closeFestiveBannerBtn");
  const closeFormBtn = document.getElementById("closeFestiveFormBtn");
  const closeSuccessBtn = document.getElementById("closeFestiveSuccessBtn");
  const claimNowBtn = document.getElementById("festiveClaimNowBtn");

  const leadForm = document.getElementById("festiveLeadForm");
  const submitBtn = document.getElementById("festiveSubmitBtn");
  const successDoneBtn = document.getElementById("festiveSuccessDoneBtn");

  // LocalStorage Keys
  const AUTO_DISABLE_KEY = "s2labs_festive_sale_auto_disabled";
  const CLAIMED_EMAILS_KEY = "s2labs_festive_claimed_emails";

  // Populate website-link hidden input
  const websiteInputs = document.querySelectorAll(".festiveWebsiteLink");
  websiteInputs.forEach((input) => {
    input.value = window.location.href;
  });

  // Switch views helper
  function switchView(target) {
    if (bannerView) bannerView.classList.remove("active");
    if (formView) formView.classList.remove("active");
    if (successView) successView.classList.remove("active");

    if (target === "banner" && bannerView) {
      bannerView.classList.add("active");
    } else if (target === "form" && formView) {
      formView.classList.add("active");
    } else if (target === "success" && successView) {
      successView.classList.add("active");
    }
  }

  // Open Popup
  function openFestivePopup(view = "banner") {
    switchView(view);
    popupMain.style.display = "flex";
    // Force reflow for smooth opacity transition
    void popupMain.offsetWidth;
    popupMain.classList.add("is-visible");
    document.body.style.overflow = "hidden";
  }

  // Close Popup
  function closeFestivePopup(markAutoDisabled = true) {
    popupMain.classList.remove("is-visible");
    document.body.style.overflow = "";

    setTimeout(() => {
      popupMain.style.display = "none";
      switchView("banner");
    }, 300);

    if (markAutoDisabled) {
      try {
        localStorage.setItem(AUTO_DISABLE_KEY, "true");
      } catch (err) {
        console.warn("LocalStorage error:", err);
      }
    }
  }

  // =========================================================================
  // 1. PAGE LOAD TRIGGER: 5-Second Delay (Only if never cancelled / filled)
  // =========================================================================
  const isAutoDisabled = localStorage.getItem(AUTO_DISABLE_KEY) === "true";

  if (!isAutoDisabled) {
    setTimeout(function () {
      // Re-check in case user interacted or opened via stripe during these 5 seconds
      if (localStorage.getItem(AUTO_DISABLE_KEY) !== "true") {
        openFestivePopup("banner");
      }
    }, 1000);
  }

  // =========================================================================
  // 2. FOOTER STRIPE CLICK: ALWAYS Open Popup
  // =========================================================================
  function bindStripeTrigger() {
    const stripeElements = document.querySelectorAll(
      ".festive-stripe-trigger, .stripe-desktop-part, .event-stripe, #festiveOfferBtn, .festive-offer-button-wrapper",
    );

    stripeElements.forEach((el) => {
      el.addEventListener("click", function (e) {
        // Prevent default navigation
        e.preventDefault();
        e.stopPropagation();
        openFestivePopup("banner");
      });
    });
  }

  bindStripeTrigger();

  // =========================================================================
  // 3. CLAIM NOW BUTTON -> Open Form View
  // =========================================================================
  if (claimNowBtn) {
    claimNowBtn.addEventListener("click", function (e) {
      e.preventDefault();
      switchView("form");
    });
  }

  // =========================================================================
  // 4. CLOSE BUTTONS & BACKDROP DISMISS (Marks auto-disabled for life)
  // =========================================================================
  if (closeBannerBtn) {
    closeBannerBtn.addEventListener("click", () => closeFestivePopup(true));
  }
  if (closeFormBtn) {
    closeFormBtn.addEventListener("click", () => closeFestivePopup(true));
  }
  if (closeSuccessBtn) {
    closeSuccessBtn.addEventListener("click", () => closeFestivePopup(true));
  }
  if (successDoneBtn) {
    successDoneBtn.addEventListener("click", () => closeFestivePopup(true));
  }
  if (backdrop) {
    backdrop.addEventListener("click", () => closeFestivePopup(true));
  }

  // =========================================================================
  // 5. HELPER: Claimed Emails Storage Management
  // =========================================================================
  function getClaimedEmails() {
    try {
      const stored = localStorage.getItem(CLAIMED_EMAILS_KEY);
      if (!stored) return [];
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveClaimedEmail(email) {
    try {
      const emails = getClaimedEmails();
      const normalized = email.trim().toLowerCase();
      if (!emails.includes(normalized)) {
        emails.push(normalized);
        localStorage.setItem(CLAIMED_EMAILS_KEY, JSON.stringify(emails));
      }
      localStorage.setItem(AUTO_DISABLE_KEY, "true");
    } catch (e) {
      console.warn("Error saving claimed email:", e);
    }
  }

  // =========================================================================
  // 6. FORM VALIDATION & SUBMISSION WITH JUSTVALIDATE
  // =========================================================================
  if (leadForm) {
    const validator = new JustValidate(leadForm, {
      validateBeforeSubmitting: true,
      errorLabelCssClass: "just-validate-error-label",
    });

    const nameInput = leadForm.querySelector('[name="full-name"]');
    const emailInput = leadForm.querySelector('[name="email"]');
    const phoneInput = leadForm.querySelector('[name="phone"]');
    const courseSelect = leadForm.querySelector('[name="preffered-course"]');

    if (nameInput) {
      validator.addField(nameInput, [
        { rule: "required", errorMessage: "Full name is required" },
        {
          rule: "minLength",
          value: 2,
          errorMessage: "Enter at least 2 characters",
        },
      ]);
    }

    if (emailInput) {
      validator.addField(emailInput, [
        { rule: "required", errorMessage: "Email address is required" },
        { rule: "email", errorMessage: "Please enter a valid email address" },
      ]);
    }

    if (phoneInput) {
      validator.addField(phoneInput, [
        { rule: "required", errorMessage: "Phone number is required" },
        {
          rule: "minLength",
          value: 8,
          errorMessage: "Please enter a valid phone number",
        },
      ]);
    }

    if (courseSelect) {
      validator.addField(courseSelect, [
        { rule: "required", errorMessage: "Please select your course" },
      ]);
    }

    validator.onSuccess(async function (event) {
      event.preventDefault();

      const fullName = (nameInput?.value || "").trim();
      const email = (emailInput?.value || "").trim();
      const phone = (phoneInput?.value || "").trim();
      const course = courseSelect?.value || "";

      const normalizedEmail = email.toLowerCase();
      const claimedEmails = getClaimedEmails();

      // Check if this email has already claimed the offer
      if (claimedEmails.includes(normalizedEmail)) {
        Swal.fire({
          icon: "info",
          title: "Already Claimed!",
          text: "This email address has already been used to claim the Festive Offer.",
          confirmButtonColor: "#0E3D56",
          confirmButtonText: "Got it",
        });
        return;
      }

      // Split name for CRM
      const nameParts = fullName.split(" ");
      const firstName = nameParts[0] || fullName;
      const lastName = nameParts.slice(1).join(" ") || "Student";

      const formData = new FormData();
      formData.append("first-name", firstName);
      formData.append("last-name", lastName);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("preffered-course", course);
      formData.append("course-name", course);
      formData.append("course-title", course);
      formData.append("interested-course", course);
      formData.append("interested-course-static", course);
      formData.append("lsource", "festive-offer-26");
      formData.append("website-link", window.location.href);
      formData.append("leadcreate", "leadcreate");

      if (submitBtn) {
        submitBtn.disabled = true;
        const spanEl = submitBtn.querySelector("span");
        if (spanEl) spanEl.textContent = "Unlocking...";
      }

      try {
        const response = await fetch(
          "/wp-content/themes/s2-labs/student-form.php",
          {
            method: "POST",
            body: formData,
          },
        );

        if (response.ok) {
          // Save email in claimed emails and disable auto popup
          saveClaimedEmail(email);

          // Reset form fields
          leadForm.reset();

          // Show Step 3 Success View
          switchView("success");
        } else {
          Swal.fire({
            icon: "error",
            title: "Submission Error",
            text: "Something went wrong. Please try again.",
            confirmButtonColor: "#0E3D56",
          });
        }
      } catch (err) {
        console.error("Festive Lead Form Error:", err);
        Swal.fire({
          icon: "error",
          title: "Connection Error",
          text: "Failed to submit. Please check your network connection.",
          confirmButtonColor: "#0E3D56",
        });
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          const spanEl = submitBtn.querySelector("span");
          if (spanEl) spanEl.textContent = "Unlock My Offer";
        }
      }
    });
  }
});
